import { FormattedMessage } from "react-intl";
import React from "react";
import PropTypes from "prop-types";
import Image from "../../general-components/image/image";
import { isPromoted } from "@default/lib/is-promoted";

const MainPresenterSponsoredImage = ({ content }) => {
  // Sponsored Events can have uncut, standard Images because this function is sold.
  if (
    isPromoted(content) &&
    !!content.fieldImage &&
    !content.fieldSponsoredCroppedImage
  ) {
    return (
      <div className="col-12 offset-lg-2 col-lg-8 main-presenter-sponsored-image">
        <Image
          data={content.fieldImage?.fieldMediaImage}
          nodeTitle={content.label}
          style={content.fieldImage?.fieldMediaImage?.styleDownload}
        />
      </div>
    );
  }
};

export const mainPresenterSponsoredImagePropTypes = PropTypes.shape({
  label: PropTypes.string,
  fieldEventType: PropTypes.string,
  fieldSponsoredCroppedImage: PropTypes.bool,
  fieldImage: PropTypes.shape({
    fieldMediaImage: PropTypes.shape({
      alt: PropTypes.string,
      title: PropTypes.string,
      styleDownload: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
});

MainPresenterSponsoredImage.propTypes = {
  content: mainPresenterSponsoredImagePropTypes,
};

export default MainPresenterSponsoredImage;
